import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductActionCallouts extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      createWishlistBtn: '.js-create-wishlist-btn',
      swymWishlistBtn: '.swym-button.swym-add-to-wishlist',
    };

    this.dom = {
      $component: component,
      $createWishlistBtn: this.$get(this.refs.createWishlistBtn),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    if (dom.$createWishlistBtn) {
      this.setClick(dom.$createWishlistBtn, this.triggerWishlist);
    }
  }

  triggerWishlist() {
    const { refs } = this;
    const wishlistBtn = document.querySelector(refs.swymWishlistBtn);

    if (!wishlistBtn) return;
    wishlistBtn.click();
  }
}
